export const MODULE_NAME = 'mailTemplates';
